import { JSONToObject } from '../../../utils/type-check';

const CUSTOMER_SERVICE_BUSINESS_IDS = new Set([
  'customer_service_plugin',
  'customerService',
  'customer_service',
  'tui_customer_service',
]);

export function isCustomerServicePluginMessage(message: any): boolean {
  const payloadData = JSONToObject(message?.payload?.data);
  const businessID = payloadData?.businessID || payloadData?.businessId || payloadData?.type;
  return CUSTOMER_SERVICE_BUSINESS_IDS.has(String(businessID));
}

export function isCustomServiceMessageInvisible(message: any): boolean {
  const payloadData = JSONToObject(message?.payload?.data);
  return Boolean(payloadData?.invisible || payloadData?.isInvisible);
}
